import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { initializeSentry } from './utils/sentry';
import { initializePlausible } from './utils/plausible';

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('PWA service worker registration failed:', error);
    });
  });
}

const removeLegacyDocumentActions = () => {
  const headings = Array.from(document.querySelectorAll('h1, h2, h3, p, div'));

  headings.forEach((element) => {
    if (element.textContent?.trim() !== 'Document actions') return;

    const container =
      element.closest('section') ??
      element.closest('[class*="rounded"]') ??
      element.parentElement?.parentElement ??
      element.parentElement;

    container?.remove();
  });
};

if (typeof document !== 'undefined') {
  removeLegacyDocumentActions();

  const documentActionsObserver = new MutationObserver(() => {
    removeLegacyDocumentActions();
  });

  documentActionsObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

// Initialize error tracking FIRST
initializeSentry();

// Initialize privacy-friendly analytics
initializePlausible();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
